import { gql } from '@apollo/client';
const REMOVE_TENANT_BRAND = gql `
  mutation RemoveTenantBrand($brandId: ID!) {
    removeBrand(brandId: $brandId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_BRAND;
